import React from 'react';
import PropTypes from 'prop-types';
import Formera from 'formera';
import MyField from './MyField';


class FormContainer extends React.Component {
 state = {
   isBooked: false,
   response: undefined,
 };
  onSubmit = (formState, { setErrors }) => {
    // alert(JSON.stringify(formState, null, 2));

    // todo check if product id 177 exists in array bookingdata

    const voucherData = { voucher: formState.values.voucher, pid: 178, hashid: this.props.hashid };

    return fetch(
      process.env.REACT_APP_VOUCHER,
      {
        method: 'post',
        headers: {
          accept: 'application/json',
          'Content-Type': 'application/json',
        },

        body: JSON.stringify(voucherData, null, 2),
      },
    ).then(this.handleResponse)
      .then(data => this.OnComplete(data))
      .catch(error => setErrors({ bookingError: error.error }, this.setState({ response: undefined })));
  }


  handleResponse(response) {
    return response.json()
      .then((json) => {
        if (response.status === 200) {
          // this.redirectOnComplete(json);
        }
        if (response.ok) {
          return json;
        }

        const error = Object.assign({}, json, {
          status: response.status,
          statusText: response.statusText,
        });
        return Promise.reject(error);
      });
  }

  OnComplete = (url) => {
    this.props.voucher(url);

    this.setState({ response: url.description });
  };


  validator = (field, { values }) => {
    const { lang } = this.props;

    const errors = {};

    if (values.voucher) {
      if (values.voucher.length !== 10 && 1 === 2) {
        errors.voucher = lang.wrongFormat;
      }
    }


    return errors;
  };

  render() {
    const initialValues = {
      /* firstName: 'Andreas',
      surName: 'Padde',
      address: 'bergslagsgatan 6',
      zip: '41104',
      city: 'gothenburg',
      phone: '031-982000',
      email: 'a@a.se', */
    };

    const styles = {
      fontFamily: 'sans-serif',
      textAlign: 'left',
    };

    const {
      bookingData, inputFields, hashId, lang,
    } = this.props;
    const { isBooked, response } = this.state;

    return (
      <div style={styles}>


        <Formera
          onSubmit={this.onSubmit}
          validate={this.validator}
          initialValues={initialValues}
          render={({
                     isSubmitting, handleSubmit, errors, ...restFormeraProps
                   }) => (
                     <div>
                       <form className="form-horizontal" onSubmit={handleSubmit}>

                         <div className="row">
                           <div className="col-md-3" />
                           <div className="col-md-6">
                             <div className="input-group">
                               <MyField
                                 name="voucher"
                                 label={lang.placeholder}
                               />
                               <span className="input-group-btn">
                                 {isBooked ? 'Du förflyttas nu till din bokningsbekräftelse!' : (<button className="btn btn-primary" disabled={isSubmitting} >{lang.redeemButton}</button>)}
                               </span>
                             </div>

                           </div>
                         </div>


                         {errors && (
                           <div className="row">
                             <div className="col-md-3" />

                             <div className="col-md-6" style={{ color: 'red' }}>{errors.bookingError || errors.voucher}</div>
                           </div>

                         )}

                         {response && (
                           <div className="row">
                             <div className="col-md-3" />

                             <div className="col-md-6" style={{ color: 'green' }}>{lang.activated} {response}</div>
                           </div>

                         )}


                       </form>

                       {1 === 2 && (
                       <pre>{JSON.stringify(restFormeraProps, null, 2)}</pre>
              )}


                     </div>
          )}

        />
      </div>
    );
  }
}


export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/Voucher/components/FormContainer.jsx